import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeIsSummaryOpened, saveConfiguration, setPopupState } from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import { PopupState, UnitStatus } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import UnitService from '../../services/UnitService';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import MainLoader from '../Loader/MainLoader';

const CheckSaveConfigPopup = () => {
  const { popupState, currentUnit, isLoadingUnitStatus } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  const unitMutation = UnitService();
  const saveConfigurationMutation = SaveConfigurationService();

  const isCheckForSaveConfigPopupOpened = popupState === PopupState.CheckForSaveConfiguration;

  const closePopupHandler = () => {
    dispatch(setPopupState(PopupState.None));
  };

  // Load latest unit status when popup opens (like RequestBudgetPopup)
  useEffect(() => {
    if (isCheckForSaveConfigPopupOpened) {
      unitMutation.mutate();
    }
  }, [isCheckForSaveConfigPopupOpened]);

  // When data is ready, decide what to do
  useEffect(() => {
    if (!isCheckForSaveConfigPopupOpened) return;
    if (isLoadingUnitStatus) return;
    if (!currentUnit) return;

    const isBudgetRequested = currentUnit.status === UnitStatus.BudgetRequested;

    if (!isBudgetRequested) {
      // Allowed to save: trigger the save and close popup
      saveConfigurationMutation.mutate();
      dispatch(saveConfiguration());
      dispatch(changeIsSummaryOpened(false));
      closePopupHandler();
    }
  }, [isCheckForSaveConfigPopupOpened, isLoadingUnitStatus, currentUnit]);

  if (!isCheckForSaveConfigPopupOpened) return null;

  if (isLoadingUnitStatus) return null; // <MainLoader />;

  const isBudgetRequested = currentUnit && currentUnit.status === UnitStatus.BudgetRequested;

  return (
    <div className={`check-popup ${isCheckForSaveConfigPopupOpened ? 'opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isCheckForSaveConfigPopupOpened ? 'opened' : ''}`}
        type="button"
        onClick={closePopupHandler}
      />
      <div className={`panel ${isCheckForSaveConfigPopupOpened ? 'opened' : ''}`}>
        <div className="header">
          {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-title', 'Guardar configuración')}
        </div>
        {isBudgetRequested ? (
          <>
            <div className="sub-header">
              {TranslationUtility.GetFormattedMessageForUI(
                'ui-save-panel-status-already-formalized',
                // eslint-disable-next-line max-len
                'No es posible guardar porque esta vivienda ya ha sido formalizada. En caso de querer realizar modificaciones, póngase en contacto con su comercial.',
              )}
            </div>
            <div className="container-buttons">
              <button
                className="check-button"
                type="button"
                onClick={closePopupHandler}
              >
                <span>
                  {TranslationUtility.GetFormattedMessageForUI('ui-logout-panel-button', 'Aceptar')}
                </span>
              </button>
            </div>
          </>
        ) : (
          // If saving is allowed, the effect above will auto-save and close; keep UI minimal
          <div className="sub-header">
            {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-subtitle', 'Guardando configuración…')}
          </div>
        )}
        <button
          type="button"
          className="close-button"
          onClick={closePopupHandler}
        >
          <CloseButton className="icon" />
        </button>
      </div>
    </div>
  );
};

export default CheckSaveConfigPopup;
